{
  "otherOrganizations": "Outras organizações",
  "solutionIframe": "Conteúdo principal",
  "unloadPromptMessage": "Tem certeza?"
}
